<template>
  <dx-modal
    :value="show"
    @input="close"
    :title="createdKey ? 'Chave de API Criada' : 'Gerar Nova Chave de API'"
    size="md"
  >
    <template v-if="!createdKey">
      <div class="card info-card">
        <div class="card-body">
          <div class="info-item">
            <fa-icon :icon="['fal', 'key']" class="info-icon text-primary"/>
            <div class="info-content">
              <p class="mb-0">
                Uma nova chave de API será gerada. Você poderá visualizar a chave completa
                <strong>apenas uma vez</strong>, logo após a criação.
              </p>
            </div>
          </div>
          <div class="divider"></div>
          <div class="info-item">
            <fa-icon :icon="['fal', 'shield-check']" class="info-icon text-warning"/>
            <div class="info-content">
              <p class="text-bold mb-0">
                Certifique-se de copiar e armazenar a chave em um local seguro!
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="success-card">
        <div class="success-header">
          <fa-icon :icon="['fal', 'check-circle']" class="success-icon"/>
          <p class="text-bold mb-0">Chave gerada com sucesso!</p>
        </div>
        <div class="form-group mt-2">
          <label class="form-label text-bold">Sua nova chave de API:</label>
          <div class="input-group">
            <input
              type="text"
              class="form-input input-lg key-input"
              :value="createdKey"
              readonly
              ref="keyInput"
            >
            <button
              class="btn btn-primary btn-lg input-group-btn btn-icon btn-icon-left"
              @click="copyKey"
              :class="{ 'btn-success': copied }"
            >
              <fa-icon :icon="['fal', copied ? 'check' : 'copy']"/>
              {{ copied ? 'Copiado!' : 'Copiar' }}
            </button>
          </div>
        </div>
        <div class="toast toast-warning mt-2">
          <fa-icon :icon="['fal', 'exclamation-triangle']" class="mr-1"/>
          <strong>Atenção:</strong> Esta é a única vez que você poderá ver esta chave completa.
          Certifique-se de copiá-la agora!
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <button
        class="btn"
        @click="close"
        v-if="createdKey"
      >
        Fechar
      </button>
      <template v-else>
        <button class="btn" @click="close" :disabled="creating">
          Cancelar
        </button>
        <button
          class="btn btn-primary ml-2"
          @click="create"
          :disabled="creating"
        >
          <span class="loading" v-if="creating"></span>
          {{ creating ? 'Gerando...' : 'Gerar Chave' }}
        </button>
      </template>
    </template>
  </dx-modal>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      creating: false,
      createdKey: null,
      copied: false,
    };
  },
  watch: {
    show(newVal) {
      if (!newVal) {
        setTimeout(() => {
          this.createdKey = null;
          this.copied = false;
        }, 300);
      }
    },
  },
  methods: {
    create() {
      this.creating = true;

      this.$http.post('/gateway/api-keys')
        .then(({ data }) => {
          this.createdKey = data.apiKey || data.key;
          this.$toast.success('Chave de API criada com sucesso');
          this.$emit('created', data);
        })
        .catch((error) => {
          this.$toast.error(error);
          this.close();
        })
        .finally(() => {
          this.creating = false;
        });
    },
    copyKey() {
      this.$refs.keyInput.select();
      document.execCommand('copy');
      this.copied = true;

      setTimeout(() => {
        this.copied = false;
      }, 3000);
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "./src/assets/scss/_variables.scss";

  .info-card {
    background-color: $bg-color;
    border: $border-width solid $border-color;

    .info-item {
      display: flex;
      gap: 1rem;
      align-items: center;

      .info-icon {
        font-size: 1.5rem;
      }

      .info-content {
        flex: 1;
      }
    }
  }

  .success-card {
    .success-header {
      display: flex;
      align-items: center;
      gap: $layout-spacing-lg;
      padding: $layout-spacing-lg;
      background-color: $success-color;
      color: white;
      border-radius: $border-radius;
      margin-bottom: $layout-spacing-xl;

      .success-icon {
        font-size: $unit-5;
      }
    }
  }

  .key-input {
    font-size: $font-size-lg;
    font-weight: 600;
  }
</style>
